<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'UserList' }" class="nav-link">Użytkownicy</router-link>/<span v-if="item && !loading">{{ item['name'] }} {{ item['surname'] }}</span></h2>
			<div v-if="item && !loading && !resetPasswordLoading" class="page-title__buttons">
				<router-link :to="{name: 'UserUpdate', params: { id: item.id }}" title="Edytuj" class="btn btn-default"><span>Edytuj</span><svg-icon name="edit"/></router-link>
				<button @click="resetPassword(item)" title="Resetuj hasło" class="btn btn-default"><span>Resetuj hasło</span><svg-icon name="padlock"/></button>
				<button @click="deleteItem(item)" class="btn btn-primary"><span>Usuń</span><svg-icon name="minus"/></button>
			</div>
		</page-title>

		<div class="col page-element">
			<div v-if="resetPasswordShowMessage" class="alert alert-success">Na adres {{resetPasswordShowMessage.email}} został wyłany email z linkiem umożliwiającym ustawienie nowego hasła</div>
			<alert-loading v-if="loading || resetPasswordLoading"></alert-loading>
			<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>
			<div v-if="deleteError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ deleteError }}</div>

			<div v-if="item && !loading && !resetPasswordLoading">
			<table class="table table-data">
			<tbody>
			<tr>
				<td>Imię: </td>
				<td>{{ item['name'] }}</td>
			</tr>
			<tr>
				<td>Nazwisko: </td>
				<td>{{ item['surname'] }}</td>
			</tr>
			<tr>
				<td>E-mail:</td>
				<td>{{ item['email'] }}</td>
			</tr>
			</tbody>
			</table>
			</div>      
		</div>
	</b-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: function() {
      return {
        resetPasswordShowMessage: false,
      }
    },
    computed: mapGetters({
      deleteError: 'user/del/error',
      deleted: 'user/del/deleted',
      error: 'user/show/error',
      loading: 'user/show/loading',
      resetPasswordLoading: 'user/reset/loading',
      resetPasswordSuccess: 'user/reset/success',
      item: 'user/show/item',
    }),
    methods: {
      deleteItem (item) {
        if (window.confirm('Czy na pewno chce usunąć tego użytkownika?'))
          this.$store.dispatch('user/del/delete', item);
      },
      resetPassword(item) {
        this.$store.dispatch('user/reset/resetPassword', item);
	  }
    },
    created () {
      this.$store.dispatch('user/show/retrieve', this.$route.params.id);
    },
    beforeDestroy() {
      this.$store.dispatch('user/show/reset');
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'UserList' });
        }
      },
      resetPasswordSuccess: function (data) {
        if (data != null) {
          this.resetPasswordShowMessage = data
          setTimeout(() => {
            this.resetPasswordShowMessage = false
            this.$store.dispatch('user/reset/reset')
          }, 5000)
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Show.vue?1a988aa4